var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-page-container"},[_c('img',{staticClass:"start-bg",attrs:{"src":_vm.start_pic_url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }